export default "__VITE_ASSET__BWXk1uGG__"